import Service from "./Service";

class LineApiService extends Service {
  constructor() {
    super("api/lines");
  }

  async getAll() {
    let result = await this.get(``, (status, data) => {
      return data;
    });
    return result;
  }

  async getStopsOnLine(lineNumber) {
    let result = await this.get(`/${lineNumber}/stops`, (status, data) => {
      return data;
    });
    return result;
  }

  async getDepartureTimeList(departStopNumber, arriveStopNumber, lineNumber, departureDate) {
    let result = await this.get(`/${lineNumber}/from/${departStopNumber}/to/${arriveStopNumber}/plannedDepartureTimes?departureDate=${departureDate}`, (status, data) => {
        return data;
      }
    );
    return result;
  }
}

export default new LineApiService();
